import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b5c48e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "recovery-wrapper"
}
const _hoisted_2 = { class: "px-6" }
const _hoisted_3 = { class: "px-6" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "new-account-wrapper px-6" }
const _hoisted_6 = {
  class: "video-bg mx-auto",
  autoplay: "",
  muted: "",
  loop: ""
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "info my-3" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "p-4" }

import { useRoute, useRouter } from 'vue-router'
import { computed, ref, onMounted } from 'vue'
import browser from 'webextension-polyfill'

import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'
import { NetworkInfoDBSchema } from '@/shared/Database/UPSettings/models'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import IconButton from '@/popup/components/shared/IconButton.vue'
import Button from '@/popup/components/shared/Button.vue'
import Animation from '@/assets/videos/animation02.mp4'
import NetworkChangeConfirmation from '@/popup/components/Modal/NetworkChangeConfirmation.vue'
import NetworkSwitchWrapper from '@/popup/components/shared/NetworkSwitchWrapper.vue'
import AccountWizard from '@/popup/components/shared/Wizard.vue'
import {
  MY_UNIVERSAL_PROFILE_DAPP,
  RECOVER_WITH_3RD_PARTY,
} from '@/shared/config'
import { useAppStore } from '@/popup/store/AppStore'
import NetworkSelect from '@/popup/components/Modal/NetworkSelect.vue'
import AddProfileActionCard from '@/popup/components/views/Onboard/CreateNewAccount/AddProfileActionCard.vue'
import TestnetLabel from '@/popup/components/shared/TestnetLabel.vue'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'
import { openInExternalPopup } from '@/popup/utils/openExternalPopup'

enum AddProfileAction {
  CREATE = 'create',
  RECOVER_WITH_2FA = 'recover',
  RECOVER_3RD_PARTY = 'recover-with-3rd-party',
  RESTORE_FROM_BACKUP = 'restore-from-backup',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddAccount',
  setup(__props) {

const ACTION = {
  [AddProfileAction.CREATE]: MY_UNIVERSAL_PROFILE_DAPP.CREATE_PROFILE_PAGE,
  [AddProfileAction.RECOVER_WITH_2FA]:
    MY_UNIVERSAL_PROFILE_DAPP.RECOVERY_PROFILE_PAGE,
  [AddProfileAction.RECOVER_3RD_PARTY]: RECOVER_WITH_3RD_PARTY,
}

const router = useRouter()
const route = useRoute()
const appStore = useAppStore()
const animation = ref(Animation)
const currentNetworkId = ref(appStore.network.id)
const isNetworkListOpen = ref(false)
const nonEmptyNetworks = ref<NetworkInfoDBSchema[]>([])

const from = route.query['from'] as string

const hasExistingAccount = computed(
  () => Object.keys(appStore.profiles).length > 0
)
const showRecoveryPage = ref(false)

const toggleNetworkListView = () => {
  isNetworkListOpen.value = !isNetworkListOpen.value
}

const onNetworkSwitch = async (networkId: string) => {
  if (currentNetworkId.value !== networkId) {
    isNetworkListOpen.value = false
    currentNetworkId.value = networkId
    await fetchNetworks()
  }
}

const handleUniversalProfile = (action: AddProfileAction) => {
  if (action === AddProfileAction.RESTORE_FROM_BACKUP) {
    openInExternalPopup(router, 'select-backup-file')
    return
  }

  if (process.env.EMBEDDED_WALLET) {
    if (window.parent !== window) {
      window.parent.postMessage(
        {
          type: 'open-tab',
          url: encodeURI(`${ACTION[action]}?network=${appStore.network.id}`),
        },
        '*'
      )
      return
    }
    window.open(
      encodeURI(`${ACTION[action]}?network=${appStore.network.id}`),
      '_blank'
    )
    return
  }
  browser.tabs.create({
    url: encodeURI(`${ACTION[action]}?network=${appStore.network.id}`),
  })
}

const fetchNetworks = async () => {
  nonEmptyNetworks.value = await useGlobals().sendMessage({
    method: InternalMethods.GET_NETWORKS,
    payload: undefined,
  })
}

onMounted(async () => {
  await fetchNetworks()
})

return (_ctx: any,_cache: any) => {
  return (showRecoveryPage.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(AccountWizard, {
          progress: 0,
          title: _ctx.$t('create_new_account.recover_title')
        }, {
          default: _withCtx(() => [
            _createVNode(SvgIcon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showRecoveryPage.value = false)),
              name: "arrow-left-lg",
              height: "24",
              width: "24",
              class: "is-clickable"
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        (hasExistingAccount.value)
          ? (_openBlock(), _createBlock(IconButton, {
              key: 0,
              class: "close-btn",
              onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/home')))
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AddProfileActionCard, {
            icon: "app-icon",
            title: _ctx.$t('create_new_account.my_up_cloud'),
            description: _ctx.$t('create_new_account.my_up_cloud_description'),
            onOnClick: _cache[2] || (_cache[2] = ($event: any) => (handleUniversalProfile(AddProfileAction.RECOVER_WITH_2FA)))
          }, null, 8 /* PROPS */, ["title", "description"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(AddProfileActionCard, {
            icon: "wallet-outline",
            title: _ctx.$t('create_new_account.recover_with_3rd_party_wallet'),
            description: 
          _ctx.$t('create_new_account.recover_with_3rd_party_description')
        ,
            onOnClick: _cache[3] || (_cache[3] = ($event: any) => (handleUniversalProfile(AddProfileAction.RECOVER_3RD_PARTY)))
          }, null, 8 /* PROPS */, ["title", "description"])
        ]),
        _createCommentVNode(" TODO: Disabling backup/restore feature until it's ready.\n    <div class=\"px-6\">\n      <AddProfileActionCard\n        icon=\"wallet-outline\"\n        :title=\"$t('create_new_account.backup_file')\"\n        :description=\"$t('create_new_account.backup_file_description')\"\n        @on-click=\"handleUniversalProfile(AddProfileAction.RESTORE_FROM_BACKUP)\"\n      />\n    </div>\n    ")
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_4, [
        (hasExistingAccount.value)
          ? (_openBlock(), _createBlock(IconButton, {
              key: 0,
              onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/'))),
              class: "mt-5"
            }))
          : _createCommentVNode("v-if", true),
        (nonEmptyNetworks.value.length > 1)
          ? (_openBlock(), _createBlock(IconButton, {
              key: 1,
              name: "switch",
              "data-testid": "network-switch-button",
              onOnClick: _cache[5] || (_cache[5] = ($event: any) => (toggleNetworkListView())),
              class: _normalizeClass(`mt-5 ${hasExistingAccount.value ? 'mr-10' : ''}`)
            }, null, 8 /* PROPS */, ["class"]))
          : _createCommentVNode("v-if", true),
        _createVNode(TestnetLabel, { class: "hanging-title" }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("video", _hoisted_6, [
            _createElementVNode("source", {
              src: animation.value,
              type: "video/mp4"
            }, null, 8 /* PROPS */, _hoisted_7)
          ]),
          _createVNode(Button, {
            variant: "primary",
            "is-full-width": true,
            class: "mt-4",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (handleUniversalProfile(AddProfileAction.CREATE)))
          }, {
            default: _withCtx(() => [
              _createVNode(SvgIcon, {
                class: "mr-2",
                color: "var(--neutral-100)",
                name: "profile-add",
                height: "24",
                width: "24"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('transaction.create_profile')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(SvgIcon, {
              class: "mr-1",
              color: "var(--neutral-20)",
              name: "information",
              height: "16",
              width: "16"
            }),
            _createElementVNode("span", {
              innerHTML: _ctx.$t('create_new_account.location_info')
            }, null, 8 /* PROPS */, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createCommentVNode(" Disable device-to-device import until we redesign the UX "),
          _createCommentVNode(" <AddProfileActionCard\n        icon=\"import-profile\"\n        :title=\"$t('create_new_account.import')\"\n        :description=\"$t('create_new_account.import_info')\"\n        @on-click=\"router.push({ path: '/qrcode/import-scan' })\"\n      /> "),
          _createVNode(AddProfileActionCard, {
            icon: "restore-profile",
            title: _ctx.$t('create_new_account.recover'),
            description: _ctx.$t('create_new_account.restore_info'),
            onOnClick: _cache[7] || (_cache[7] = ($event: any) => (showRecoveryPage.value = true))
          }, null, 8 /* PROPS */, ["title", "description"])
        ]),
        _createVNode(ModalTransition, null, {
          default: _withCtx(() => [
            (
          !_unref(appStore).state.hasDisplayedNetworkSwitchInfo && _unref(from) === 'settings'
        )
              ? (_openBlock(), _createBlock(NetworkChangeConfirmation, { key: 0 }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(ModalTransition, null, {
          default: _withCtx(() => [
            (isNetworkListOpen.value)
              ? (_openBlock(), _createBlock(NetworkSelect, {
                  key: 0,
                  onOnBackgroundClick: toggleNetworkListView,
                  onOnNetworkSwitch: onNetworkSwitch
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(NetworkSwitchWrapper)
      ]))
}
}

})